import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { paymentProvidersSelector } from '@/domain/paySettings';
import type { PaymentProviderRecord } from '@/domain/paySettings/types';

import { PAYMENT_PROVIDERS_NAMES, PAYMENT_PROVIDERS_TITLES } from '@/domain/paySettings/helpers';
import type { PaymentProviderName } from '@/domain/paySettings/helpers';

import openFinanceIcon from '@/pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/icons/openFinance.jpg';

export interface ProviderConfig {
  name: PaymentProviderName | string;
  title: string;
  icon: string;
  status: string;
  id: string | null;
}

const providersConfig: Record<PaymentProviderName, Omit<ProviderConfig, 'status' | 'id'>> = {
  [PAYMENT_PROVIDERS_NAMES.openFinance]: {
    name: PAYMENT_PROVIDERS_NAMES.openFinance,
    title: PAYMENT_PROVIDERS_TITLES[PAYMENT_PROVIDERS_NAMES.openFinance],
    icon: openFinanceIcon,
  },
};

const buildConfig = (provider: PaymentProviderRecord): ProviderConfig => {
  const baseConfig = providersConfig[provider.providerName as PaymentProviderName] ?? {
    name: '',
    title: '',
    icon: '',
  };
  return {
    ...baseConfig,
    name: baseConfig.name || provider.providerName,
    title: provider.displayName || baseConfig.title,
    status: provider.status,
    id: provider.id,
  };
};

const usePaymentProvidersConfig = (): ProviderConfig[] => {
  const providers = useSelector(paymentProvidersSelector);

  return useMemo(() => providers.map(buildConfig).toArray(), [providers]);
};

export default usePaymentProvidersConfig;
